import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LogOut, MessageCircle } from "lucide-react";
import { smallLogo } from "../../assets/images";
import { useAuth } from "../../context/auth-context";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  SidebarSeparator,
  useSidebar,
} from "../ui/sidebar";
import { navItems, SUPPORT_URL } from "./nav-items";

const AppSidebar = () => {
  const { logout } = useAuth();
  const { pathname } = useLocation();
  const { isMobile, setOpenMobile } = useSidebar();

  // On mobile the sheet must close after navigating; on desktop it stays put.
  const closeOnMobile = () => {
    if (isMobile) setOpenMobile(false);
  };

  return (
    <Sidebar collapsible="icon" className="font-manrope">
      <SidebarHeader className="h-16 justify-center px-4">
        <Link to="/dashboard" onClick={closeOnMobile} className="flex items-center">
          <img
            src={smallLogo}
            alt="Deexoptions"
            className="h-[25px] w-[90px] shrink-0 object-contain object-left transition-opacity group-data-[collapsible=icon]:opacity-0"
          />
        </Link>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {navItems.map((item) => {
              const isActive = pathname.startsWith(item.href);
              return (
                <SidebarMenuItem key={item.href}>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive}
                    tooltip={item.title}
                  >
                    <Link to={item.href} onClick={closeOnMobile}>
                      <item.icon />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              );
            })}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="gap-2">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip="Support line"
              className="bg-success text-success-foreground hover:bg-success/90 hover:text-success-foreground active:bg-success/90 active:text-success-foreground"
            >
              <a href={SUPPORT_URL} target="_blank" rel="noreferrer">
                <MessageCircle />
                <span className="font-sora font-semibold">Support Line</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>

        <SidebarSeparator className="mx-0" />

        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              tooltip="Logout"
              onClick={logout}
              className="text-destructive hover:bg-destructive/10 hover:text-destructive active:bg-destructive/10 active:text-destructive"
            >
              <LogOut />
              <span className="font-semibold">Logout</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
};

export default AppSidebar;
